import './Container.css';

interface Props extends React.PropsWithChildren {
  className?: string;
  id?: string;
}

const Container = (props: Props) => {
  return (
    <div
      className={`container ${props.className}`}
      id={props.id}
    >
      {props.children}
    </div>
  );
};

export default Container;
